export default {
  CONTAINER: 'ACTIONPOPUP_CONTAINER',
  ACTION_IMAGE: 'ACTIONPOPUP_ACTION_IMG',
  ACTION_TITLE_TEXT: 'ACTIONPOPUP_ACTION_TITLE_TEXT',
  ACTION_DESCRIPTION_TEXT: 'ACTIONPOPUP_ACTION_DESCRIPTION_TEXT',
  DAY_COST_TEXT: 'ACTIONPOPUP_DAY_COST_TEXT',
  DAY_ICON: 'ACTIONPOPUP_DAY_ICON',
  CANCEL_BUTTON_CLICK: 'ACTIONPOPUP_CANCEL_CLICK',
  PROCEED_BUTTON_CLICK: 'ACTIONPOPUP_PROCEED_CLICK',
  RESTRICTED_MESSAGE_TEXT: 'ACTIONPOPUP_RESTRICTED_MESSAGE_TEXT',
  RESTRICTED_IMAGE: 'ACTIONPOPUP_RESTRICTED_IMG',
  SURVEY_HEADING_TEXT: 'ACTIONPOPUP_SURVEY_HEADING_TEXT',
  SURVEY_QUESTION_TEXT: 'ACTIONPOPUP_SURVEY_QUESTION_TEXT',
};



